/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum PaxCheckIcaoNationality {
    ASC = 'ASC',
    AND = 'AND',
    ARE = 'ARE',
    AFG = 'AFG',
    ATG = 'ATG',
    AIA = 'AIA',
    ALB = 'ALB',
    ARM = 'ARM',
    ANT = 'ANT',
    AGO = 'AGO',
    ATA = 'ATA',
    ARG = 'ARG',
    ASM = 'ASM',
    AUT = 'AUT',
    AUS = 'AUS',
    ABW = 'ABW',
    ALA = 'ALA',
    AZE = 'AZE',
    BIH = 'BIH',
    BRB = 'BRB',
    BGD = 'BGD',
    BEL = 'BEL',
    BFA = 'BFA',
    BGR = 'BGR',
    BHR = 'BHR',
    BDI = 'BDI',
    BEN = 'BEN',
    BLM = 'BLM',
    BMU = 'BMU',
    BRN = 'BRN',
    BOL = 'BOL',
    BES = 'BES',
    BRA = 'BRA',
    BHS = 'BHS',
    BTN = 'BTN',
    BUR = 'BUR',
    BVT = 'BVT',
    BWA = 'BWA',
    BLR = 'BLR',
    BLZ = 'BLZ',
    CAN = 'CAN',
    CCK = 'CCK',
    COD = 'COD',
    CAF = 'CAF',
    COG = 'COG',
    CHE = 'CHE',
    CIV = 'CIV',
    COK = 'COK',
    CHL = 'CHL',
    CMR = 'CMR',
    CHN = 'CHN',
    COL = 'COL',
    CPT = 'CPT',
    CRI = 'CRI',
    SCG = 'SCG',
    CUB = 'CUB',
    CPV = 'CPV',
    CUW = 'CUW',
    CXR = 'CXR',
    CYP = 'CYP',
    CZE = 'CZE',
    DEU = 'DEU',
    DGA = 'DGA',
    DJI = 'DJI',
    DNK = 'DNK',
    DMA = 'DMA',
    DOM = 'DOM',
    DZA = 'DZA',
    ECU = 'ECU',
    EST = 'EST',
    EGY = 'EGY',
    ESH = 'ESH',
    ERI = 'ERI',
    ESP = 'ESP',
    ETH = 'ETH',
    FIN = 'FIN',
    FJI = 'FJI',
    FLK = 'FLK',
    FSM = 'FSM',
    FRO = 'FRO',
    FRA = 'FRA',
    FXX = 'FXX',
    GAB = 'GAB',
    GBR = 'GBR',
    GRD = 'GRD',
    GEO = 'GEO',
    GUF = 'GUF',
    GGY = 'GGY',
    GHA = 'GHA',
    GIB = 'GIB',
    GRL = 'GRL',
    GMB = 'GMB',
    GIN = 'GIN',
    GLP = 'GLP',
    GNQ = 'GNQ',
    GRC = 'GRC',
    SGS = 'SGS',
    GTM = 'GTM',
    GUM = 'GUM',
    GNB = 'GNB',
    GUY = 'GUY',
    HKG = 'HKG',
    HMD = 'HMD',
    HND = 'HND',
    HRV = 'HRV',
    HTI = 'HTI',
    HUN = 'HUN',
    IDN = 'IDN',
    IRL = 'IRL',
    ISR = 'ISR',
    IMN = 'IMN',
    IND = 'IND',
    IOT = 'IOT',
    IRQ = 'IRQ',
    IRN = 'IRN',
    ISL = 'ISL',
    ITA = 'ITA',
    JEY = 'JEY',
    JAM = 'JAM',
    JOR = 'JOR',
    JPN = 'JPN',
    KEN = 'KEN',
    KGZ = 'KGZ',
    KHM = 'KHM',
    KIR = 'KIR',
    COM = 'COM',
    KNA = 'KNA',
    PRK = 'PRK',
    KOR = 'KOR',
    KWT = 'KWT',
    CYM = 'CYM',
    KAZ = 'KAZ',
    LAO = 'LAO',
    LBN = 'LBN',
    LCA = 'LCA',
    LIE = 'LIE',
    LKA = 'LKA',
    LBR = 'LBR',
    LSO = 'LSO',
    LTU = 'LTU',
    LUX = 'LUX',
    LVA = 'LVA',
    LBY = 'LBY',
    MAR = 'MAR',
    MCO = 'MCO',
    MDA = 'MDA',
    MNE = 'MNE',
    MAF = 'MAF',
    MDG = 'MDG',
    MHL = 'MHL',
    MKD = 'MKD',
    MLI = 'MLI',
    MMR = 'MMR',
    MNG = 'MNG',
    MAC = 'MAC',
    MNP = 'MNP',
    MTQ = 'MTQ',
    MRT = 'MRT',
    MSR = 'MSR',
    MLT = 'MLT',
    MUS = 'MUS',
    MDV = 'MDV',
    MWI = 'MWI',
    MEX = 'MEX',
    MYS = 'MYS',
    MOZ = 'MOZ',
    NAM = 'NAM',
    NCL = 'NCL',
    NER = 'NER',
    NFK = 'NFK',
    NGA = 'NGA',
    NIC = 'NIC',
    NLD = 'NLD',
    NOR = 'NOR',
    NPL = 'NPL',
    NRU = 'NRU',
    NTZ = 'NTZ',
    NIU = 'NIU',
    NZL = 'NZL',
    OMN = 'OMN',
    PAN = 'PAN',
    PER = 'PER',
    PYF = 'PYF',
    PNG = 'PNG',
    PHL = 'PHL',
    PAK = 'PAK',
    POL = 'POL',
    SPM = 'SPM',
    PCN = 'PCN',
    PRI = 'PRI',
    PSE = 'PSE',
    PRT = 'PRT',
    PLW = 'PLW',
    PRY = 'PRY',
    QAT = 'QAT',
    REU = 'REU',
    ROU = 'ROU',
    SRB = 'SRB',
    RUS = 'RUS',
    RWA = 'RWA',
    SAU = 'SAU',
    SLB = 'SLB',
    SYC = 'SYC',
    SDN = 'SDN',
    SWE = 'SWE',
    SGP = 'SGP',
    SHN = 'SHN',
    SVN = 'SVN',
    SJM = 'SJM',
    SVK = 'SVK',
    SLE = 'SLE',
    SMR = 'SMR',
    SEN = 'SEN',
    SOM = 'SOM',
    SUR = 'SUR',
    SSD = 'SSD',
    STP = 'STP',
    SUN = 'SUN',
    SLV = 'SLV',
    SXM = 'SXM',
    SYR = 'SYR',
    SWZ = 'SWZ',
    TAA = 'TAA',
    TCA = 'TCA',
    TCD = 'TCD',
    ATF = 'ATF',
    TGO = 'TGO',
    THA = 'THA',
    TJK = 'TJK',
    TKL = 'TKL',
    TLS = 'TLS',
    TKM = 'TKM',
    TUN = 'TUN',
    TON = 'TON',
    TMP = 'TMP',
    TUR = 'TUR',
    TTO = 'TTO',
    TUV = 'TUV',
    TWN = 'TWN',
    TZA = 'TZA',
    UKR = 'UKR',
    UGA = 'UGA',
    UMI = 'UMI',
    USA = 'USA',
    URY = 'URY',
    UZB = 'UZB',
    VAT = 'VAT',
    VCT = 'VCT',
    VEN = 'VEN',
    VGB = 'VGB',
    VIR = 'VIR',
    VNM = 'VNM',
    VUT = 'VUT',
    WLF = 'WLF',
    WSM = 'WSM',
    XXI = 'XXI',
    XXU = 'XXU',
    XKX = 'XKX',
    YEM = 'YEM',
    MYT = 'MYT',
    YUG = 'YUG',
    ZAF = 'ZAF',
    ZMB = 'ZMB',
    ZAR = 'ZAR',
    ZWE = 'ZWE',
    D = 'D',
    EUE = 'EUE',
    GBD = 'GBD',
    GBN = 'GBN',
    GBO = 'GBO',
    GBP = 'GBP',
    GBS = 'GBS',
    UNA = 'UNA',
    UNK = 'UNK',
    UNO = 'UNO',
    XBA = 'XBA',
    XIM = 'XIM',
    XCC = 'XCC',
    XCO = 'XCO',
    XEC = 'XEC',
    XPO = 'XPO',
    XOM = 'XOM',
    XXA = 'XXA',
    XXB = 'XXB',
    XXC = 'XXC',
    XXX = 'XXX',
    ZIM = 'ZIM',
    NSK = 'NSK',
    RKS = 'RKS',
    WSA = 'WSA',
    XCT = 'XCT'
}


export function instanceOfPaxCheckIcaoNationality(value: any): boolean {
    for (const key in PaxCheckIcaoNationality) {
        if (Object.prototype.hasOwnProperty.call(PaxCheckIcaoNationality, key)) {
            if (PaxCheckIcaoNationality[key as keyof typeof PaxCheckIcaoNationality] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PaxCheckIcaoNationalityFromJSON(json: any): PaxCheckIcaoNationality {
    return PaxCheckIcaoNationalityFromJSONTyped(json, false);
}

export function PaxCheckIcaoNationalityFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckIcaoNationality {
    return json as PaxCheckIcaoNationality;
}

export function PaxCheckIcaoNationalityToJSON(value?: PaxCheckIcaoNationality | null): any {
    return value as any;
}

export function PaxCheckIcaoNationalityToJSONTyped(value: any, ignoreDiscriminator: boolean): PaxCheckIcaoNationality {
    return value as PaxCheckIcaoNationality;
}

